import { getSupabase } from "@/lib/supabase-lazy";

export interface InsightsSsrData {
  articles: any[];
  categories: any[];
}

/** Datos del listado de Insights, cargados en el loader para que salgan en el HTML (SSR). */
export async function fetchInsightsSsrData(): Promise<InsightsSsrData> {
  const supabase = await getSupabase();
  const [articlesRes, catsRes] = await Promise.all([
    supabase
      .from("blog_articles_public")
      .select("id, slug, slug_es, slug_en, article_type, title_es, title_en, excerpt_es, excerpt_en, cover_image_url, cover_image_alt, featured_image_alt_es, featured_image_alt_en, featured_image_title, published_at, category_id")
      .order("published_at", { ascending: false }),
    supabase.from("blog_categories").select("*").order("sort_order"),
  ]);
  return {
    articles: articlesRes.data ?? [],
    categories: catsRes.data ?? [],
  };
}
